import Vue from "vue";

import Loading from "@/components/common/loading.vue";
import confirm from "@/components/common/confirm.vue";
import microLoading from "@/components/common/loading-micro.vue";

import customImage from "@/components/custom/image.vue";
import customSelect from "@/components/custom/select.vue";
import customSelectMultiple from "@/components/custom/select-multiple.vue";
import customSwitch from "@/components/custom/switch.vue";
import customMonthPicker from "@/components/custom/monthPicker.vue";

import userEdit from "@/components/users/edit.vue";
import userInvite from "@/components/users/invite.vue";

Vue.component("userEdit", userEdit);
Vue.component("userInvite", userInvite);
Vue.component("confirm", confirm);
Vue.component("loading", Loading);
Vue.component("microLoading", microLoading);
Vue.component("customImage", customImage);
Vue.component("customSelect", customSelect);
Vue.component("customSelectMultiple", customSelectMultiple);
Vue.component("customMonthPicker", customMonthPicker);
Vue.component("customSwitch", customSwitch);
